import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import checkPermission from '../../../../../../Components/Hooks/PermissionHook';
import { setCreativesLoader } from '../../../../../../slices/analytics/reducer';
import { deleteFacebookProperties } from '../../../../../../slices/campaigns/facebook/thunk';

function UnPublishBtn() {
  const dispatch = useDispatch();

  const selectState = createSelector(state => state, (state) => ({
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    currentVersion: state.Campaign.currentVersion,
    facebookId: state.Campaign.facebookId,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    facebookStatus: state.Campaign.facebookStatus
  }));
  const {
    brandPath,
    marketPath,
    currentVersion,
    facebookId,
    isFacebookPropertiesSet,
    facebookStatus
  } = useSelector(selectState);

  async function unPublishFacebook() {
    dispatch(setCreativesLoader(true));
    await dispatch(deleteFacebookProperties());
    dispatch(setCreativesLoader(false));
  }

  return (
    <React.Fragment>
      {checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignPublish") ?
        (facebookId && isFacebookPropertiesSet && facebookStatus) ?
          <button className='btn btn-danger' onClick={unPublishFacebook}>
            <i className='mdi mdi-publish-off me-2'></i>
            Unpublish
          </button>
          : null
        : null}
    </React.Fragment>
  )

}

export default UnPublishBtn
